import script from "./BuilderView3.vue?vue&type=script&setup=true&lang=js"
export * from "./BuilderView3.vue?vue&type=script&setup=true&lang=js"

import "./BuilderView3.vue?vue&type=style&index=0&id=ed0e28c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed0e28c2"]])

export default __exports__